import styled, { css } from 'styled-components';

export const StyledAudioCall = styled.div<{
  $hasVideo: boolean;
}>`
  width: 100%;
  height: 100%;
  background-image: url('/images/call_bg.webp');
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  .audio-call-content {
    position: relative;
    flex: 1;
    display: flex;
    justify-content: center;
    padding: 24px;
  }
  .audio-call-buttons {
    height: 100px;
    background-color: rgba(24, 33, 44, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 32px;
  }
  ${({ $hasVideo }) =>
    $hasVideo
      ? css`
          .audio-call-content {
            align-items: flex-start;
          }
        `
      : css`
          .audio-call-content {
            align-items: center;
          }
        `}
`;

export const StyledAudioCallVideo = styled.div<{ $small?: boolean }>`
  position: absolute;
  z-index: 0;
  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  ${({ $small }) =>
    $small
      ? css`
          right: 24px;
          bottom: 24px;
          width: 150px;
          height: 150px;
        `
      : css`
          inset: 0;
        `}
`;

export const StyledFullScreen = styled.div`
  position: absolute;
  z-index: 3;
  left: 24px;
  top: 24px;
`;
